// Plain Home capability labels; questions remain in dedicated FAQ sections.
export const HOME_CAPABILITY_LEARNING = {
  "C-01": {
    "desc": "Energetic devices release energy for a defined purpose. A cartridge or initiator can start a function in a larger assembly or supply energy for a mechanical action. Explore the product families to see how their roles differ.",
    "learnMore": {
      "to": "/energetics",
      "label": "Explore energetic devices"
    },
    "title": "Energetic devices"
  },
  "C-02": {
    "desc": "Materials processing turns raw stock into components with the required shape, surface and properties. Machining, surface finishing, composite fabrication and precision bonding serve different production needs.",
    "learnMore": {
      "to": "/capabilities",
      "label": "Explore manufacturing processes"
    },
    "title": "Materials processing"
  },
  "C-03": {
    "desc": "A hermetic seal helps protect the inside of a component from its surroundings. Sealing, welding and leak testing support that protected internal environment.",
    "learnMore": {
      "to": "/energetics/missile-components",
      "label": "Explore energetic components"
    },
    "title": "Hermetic sealing"
  },
  "C-04": {
    "desc": "Qualification testing checks a product against defined program requirements. Environmental, mechanical and functional testing is coordinated through in-house capabilities and qualified specialist suppliers as required.",
    "learnMore": {
      "to": "/quality-testing",
      "label": "Explore qualification testing"
    },
    "title": "Qualification testing"
  },
  "C-05": {
    "desc": "Inspection checks whether parts and assemblies meet the specified requirements. Measurements and production records connect each result to the item or lot being delivered.",
    "learnMore": {
      "to": "/quality-testing",
      "label": "Explore quality inspection"
    },
    "title": "Quality inspection"
  }
};
